import { Typography } from '@mui/material';

interface Props {
  label: string;
  value: string;
}

const Filter = ({ label, value }: Props) => (
  <>
    <Typography variant="body1">{label}</Typography>
    <Typography variant="body2">{value}</Typography>
  </>
);

export default Filter;
